export default __webpack_public_path__ + "images/assets/a3c319c2e7d8a4b3b0a476d8df90ad77.svg";